import * as types from './actionTypes'

export function startReciveFolders() {
  return { type: types.BEGIN_FETCH_FOLDERS }
}
export function finishReciveFolders() {
  return { type: types.FINISH_FETCH_FOLDERS }
}

export function reciveFolders(folders) {
  return { type: types.FETCH_FOLDERS, folders }
}

export function startReciveUserAllWatchedVideos() {
  return { type: types.BEGIN_FETCH_USER_ALL_WATCHED_VIDEOS }
}
export function finishReciveUserAllWatchedVideos() {
  return { type: types.FINISH_USER_ALL_WATCHED_VIDEOS }
}

export function reciveUserAllWatchedVideos(videos) {
  return { type: types.FETCH_USER_ALL_WATCHED_VIDEOS, videos }
}

export function startReciveUserFolderWatchedVideos() {
  return { type: types.BEGIN_FETCH_USER_FOLDER_WATCHED_VIDEOS }
}
export function finishReciveUserFolderWatchedVideos() {
  return { type: types.FINISH_USER_FOLDER_WATCHED_VIDEOS }
}

export function reciveUserFolderWatchedVideos(videos) {
  return { type: types.FETCH_USER_FOLDER_WATCHED_VIDEOS, videos }
}

const setUserUnlockedMiazgas = (unlockedMiazgas) => {
  return (dispatch) => {
    dispatch({ type: types.ADD_UNLOCKED_MIAZGA_ID, unlockedMiazgas })
  }
}

export function fetchUserFolderWatchedVideos(videos) {
  return (dispatch) => {
    dispatch(startReciveUserFolderWatchedVideos())
    dispatch(reciveUserFolderWatchedVideos(videos))
    dispatch(finishReciveUserFolderWatchedVideos())
  }
}

export function fetchUserAllWatchedVideos(videos) {
  return (dispatch) => {
    dispatch(startReciveUserAllWatchedVideos())
    dispatch(reciveUserAllWatchedVideos(videos))
    dispatch(finishReciveUserAllWatchedVideos())
  }
}

export function fetchFolders(folders) {
  return (dispatch) => {
    dispatch(startReciveFolders())
    dispatch(reciveFolders(folders))
    dispatch(finishReciveFolders())
  }
}
